// 导入封装好的网络请求类工具
import service from "./axios";

// 登录
export const login = data => {
  return service({
    url: "/apply/login",
    method: "post",
    params: {
      idCode: data.idCode,
      password: data.password,
    },
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/login.js